import { CommonEvaluation, CommonEvaluationRequest } from '@codidae/common-types';
import { ChatbotResponse } from '../hooks/use-chatbot';
import HTTPClient from 'utils/HTTPClient';

// Interface EvaluationDto supprimée car createEvaluation et editEvaluation sont retirées

// Gardée - Utilisée par evaluations.tsx
export function getEvaluations(childrenId: number): Promise<CommonEvaluation[]> {
  return HTTPClient.get(`/evaluation/${childrenId}`).then((data) => data.data);
}

// Fonction createEvaluation supprimée

// Renommer la fonction et adapter l'endpoint
export function deleteEvaluation(id: number): Promise<any> { // id est maintenant evaluationId
  console.log(`[Service][deleteEvaluation] Calling DELETE /evaluation/${id}`);
  return HTTPClient.delete(`/evaluation/${id}`).then((data) => data.data);
}

// MODIFIER ICI : La fonction retourne maintenant une Promise<ChatbotResponse>
export function chatbotRequest(body: {
  message?: string;
  childrenId: number;
  requestId?: number;
}): Promise<ChatbotResponse> { // Changer le type de retour ici
  // Le payload reste le même, mais la réponse attendue change
  return HTTPClient.post('/evaluation/chatbot-request', body).then((data) => data.data);
}

// Gardée - Utilisée par chatbot.tsx (menu)
export function deleteChatbotRequest(id: number): Promise<any> {
  return HTTPClient.delete(`/evaluation/chatbot-request/${id}`).then((data) => data.data);
}

// Gardée - Utilisée par use-chatbot.ts et chatbot.tsx (menu)
export function getChatbotRequests(): Promise<CommonEvaluationRequest[]> {
  return HTTPClient.get('/evaluation/chatbot-requests').then((data) => data.data);
}

// Fonction getEvaluationById supprimée

// Fonction logLocalInteraction supprimée
